import { Dispatch } from "react";
import { getLinks } from "../../../store/slices/linkListSlice";
import { AsyncThunkAction } from "@reduxjs/toolkit";
import { sendTypeIds } from "../../../constants/options/sendOptions";

export function refreshLinksTable(dispatch: Dispatch<AsyncThunkAction<any, any, any>>) {
    const today = new Date();
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 7);
    var start = sevenDaysAgo;
    var end = today;
    var startDate = "";
    var endDate = "";
    if (start) {
        startDate = start.getDate() + "/" + (start.getMonth() + 1) + "/" + start.getFullYear();
    }
    if (end) {
        endDate = end.getDate() + "/" + (end.getMonth() + 1) + "/" + end.getFullYear();
    }

    const parameters = {
        startDate: startDate,
        endDate: endDate,
        sendType: sendTypeIds.all,
        linkStatus: 0,
        paymentProvider: 0,
        paymentStatus: 0,
        startAmount: null,
        endAmount: null,
        customerName: "",
        email: "",
        phone: ""
    };
    dispatch(getLinks({ parameters }));
}